import ServicesSection from '../Sections/ServicesSection';
import ServicesFooter from '../Sections/ServicesFooter';
import BottomFooterAbout from "../Sections/bottomFooterAbout";
import WhatsappWidget from "../Components/Whatsapp Widget/WhatsappWidget";

function Services() {
  return (
    <>
      <ServicesSection />
      <ServicesFooter />
      <BottomFooterAbout />
      <WhatsappWidget />
    </>
  );
}

export default Services;
